'use strict';

var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var iconStyles = require('../iconStyles.js');
var SvgIcon = require('../../node_modules/@material-ui/core/esm/SvgIcon/SvgIcon.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var PodiumAppIcon = function PodiumAppIcon(props) {
  return React__default["default"].createElement(SvgIcon["default"], _objectSpread({}, props, {
    viewBox: "0 0 400 400"
  }), React__default["default"].createElement("path", {
    d: "M241.3,55.9H64.7c-2.7,0-4.8,1.4-4.8,4v237v59.3c0,7.3,4.2,9.1,9.4,3.9l26.9-26.9l34.6-34.2\n\tc0.9-0.9,2.8-1.3,4.1-1.3h106.4c64,0,114.9-56.2,114.9-120.9S305.3,55.9,241.3,55.9z M120.3,118c0-1.3,1.1-2.4,2.4-2.4H263\n\tc1.3,0,2.4,1.1,2.4,2.4v17.8c0,1.3-1.1,2.4-2.4,2.4H122.7c-1.3,0-2.4-1.1-2.4-2.4V118z M265.4,234.1c0,1.3-1.1,2.4-2.4,2.4H122.7\n\tc-1.3,0-2.4-1.1-2.4-2.4v-17.8c0-1.3,1.1-2.4,2.4-2.4H263c1.3,0,2.4,1.1,2.4,2.4V234.1z M295.7,184.9c0,1.3-1.1,2.4-2.4,2.4H123.3\n\tc-1.3,0-2.4-1.1-2.4-2.4v-17.8c0-1.3,1.1-2.4,2.4-2.4h169.9c1.3,0,2.4,1.1,2.4,2.4V184.9z"
  }));
};

var PodiumAppIcon$1 = iconStyles()(PodiumAppIcon);

module.exports = PodiumAppIcon$1;
